import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import { Button, Row, Col, Container, Label, Input } from "reactstrap";
import ModalFrame from "../../../../toolkit/modalFrame";
import BaseInput from "../../../../toolkit/baseInput";
import { getMonthsWithoutInterestsByBankId } from "../../../actions/banks";
import { handleRequestError } from "../../../../utils/helpers";
import BaseButtonWithIconAndTooltip from "../../../../toolkit/baseButtonWithIconAndTooltip";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import MexicanCurrency from "../../common/currency";
import LineaPagoModalMultipleRow from "./LineaPagoModalMultipleRow";

export interface LineaPagoConfig {
  tokenizar: boolean;
  msi: any;
  monto: Number;
}

interface Props {
  isOpen: boolean;
  amount: number;
  hasMembershipsOrTokenizationProducts: boolean;
  hasMaintenancesProducts: boolean;
  showTokenizationControl: boolean;
  allowTokenize: boolean;
  generarLineaPago: (lineasPago: LineaPagoConfig[]) => any;
  cancelar: () => any;
}

interface State {
  lineasPago: LineaPagoConfig[];
  msiCatalog: any;
}

class LineaPagoModalMultiple extends React.Component<Props, State> {
  state = {
    lineasPago: [{ tokenizar: false, msi: null, monto: 0 }],
    msiCatalog: []
  };

  componentDidMount() {
    getMonthsWithoutInterestsByBankId(342)
      .then(({ data }) => {
        this.setState({ msiCatalog: [...data] });
      })
      .catch(handleRequestError);
  }

  componentWillUnmount() {
    this.setState({ lineasPago: [{ tokenizar: false, msi: null, monto: 0 }] });
  }

  getMsiCatalog() {
    const total = this.props.amount || 0;

    const _defOptions = [{ value: null, label: "Contado" }];

    let options = [];
    if (!this.props.hasMaintenancesProducts) {
      options = (this.state.msiCatalog || [])
        .filter(x => (x.monto || 0) <= total)
        .map(x => {
          return { value: x.meses, label: x.meses };
        });
    }

    return [..._defOptions, ...options];
  }

  render() {
    return (
      <Container className="p-0">
        <ModalFrame
          title={"Generar línea de pago"}
          isOpen={this.props.isOpen}
          size="lg"
        >
          <div>
            Se crearán las líneas de pago configuradas con todos los items
            seleccionados. ¿Desea continuar?
          </div>
          <br />
          <Row className={`${s.customDistancia}`}>
            <Col xs={6} md={6} lg={6}>
              Total: {<MexicanCurrency quantity={this.props.amount} />}
            </Col>

            <Col xs={2} md={2} lg={2}>
              <Button
                block
                color=""
                onClick={() => {
                  const { lineasPago } = this.state;
                  this.setState({
                    lineasPago: [
                      ...lineasPago,
                      { tokenizar: false, msi: null, monto: 0 }
                    ]
                  });
                }}
              >
                Agregar
              </Button>
            </Col>
          </Row>
          <br />
          {this.state.lineasPago.map((lp, idx) => {
            return (
              <LineaPagoModalMultipleRow
                index={idx}
                allowTokenize={this.props.allowTokenize}
                lineaPago={lp}
                msiCatalog={this.getMsiCatalog()}
                updateLineaPago={(lp: LineaPagoConfig, index: number) => {
                  const lineasPago = [...this.state.lineasPago];
                  lineasPago[index] = { ...lp };
                  this.setState({ lineasPago: [...lineasPago] });
                }}
                deleteLineaPago={(lp: LineaPagoConfig, index: number) => {
                  const { lineasPago } = this.state;
                  lineasPago.slice(index, 1);
                  this.setState({ lineasPago: [...lineasPago] });
                }}
              />
            );
          })}
          <hr />
          <Row className={`${s.customDistancia}`}>
            <Col xs={6} md={6} lg={6}>
              <Button block color="secondary" onClick={() => {}}>
                Generar líneas de pago
              </Button>
            </Col>

            <Col xs={6} md={6} lg={6}>
              <Button
                block
                color="primary"
                onClick={() => {
                  if (this.props.cancelar) {
                    this.setState({ lineasPago: [] });
                    this.props.cancelar();
                  }
                }}
              >
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFrame>
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(LineaPagoModalMultiple));
